<template>
  <div>
    <ul>
      <v-card variant="outlined" width="1000px" class="transcription">
        <v-card-title>Transcription</v-card-title>
        <v-card-text>{{ transcription.note }}</v-card-text>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-container ref="scrollTarget" style="height: 450px" class="overflow-y-auto">
                <v-row v-for="msg in transcription.messages" :key="msg.timestamp" dense>
                  <v-col v-if="msg.speaker == 'Teacher'">
                    <div class="balloon_l">
                      <div class="face_icon">
                        <v-avatar color="primary" size="56">
                          <span class="white--text">
                            {{ msg.speaker }}
                          </span>
                        </v-avatar>
                      </div>
                      <p class="says">
                        {{ msg.text }}
                      </p>
                      <span class="timestamp_l">
                        {{ msg.timestamp }}
                      </span>
                    </div>
                  </v-col>
                  <v-col v-else>
                    <div class="balloon_r">
                      <div class="face_icon">
                        <v-avatar color="secondary" size="56">
                          <span class="white--text">
                            {{ msg.speaker }}
                          </span>
                        </v-avatar>
                      </div>
                      <span class="timestamp_r">
                        {{ msg.timestamp }}
                      </span>
                      <p class="says">
                        {{ msg.text }}
                      </p>
                    </div>
                  </v-col>
                </v-row>
              </v-container>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </ul>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { Transcription } from '@/models/models';

export default defineComponent({
  name: 'TranscribedData',
  props: {
    transcription: {
      type: Object as PropType<Transcription>,
      required: true
    }
  },
});
</script>

<style lang="scss" scoped>
@import '@/assets/sass/size.scss';

.transcription {
  margin: 20px auto;
}

.balloon_l,
.balloon_r {
  margin: 10px 0;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
}

.balloon_r {
  justify-content: flex-end;
}

.face_icon img {
  width: 80px;
  height: auto;
}

.balloon_r .face_icon {
  margin-left: 25px;
}

.balloon_l .face_icon {
  margin-right: 25px;
}

.balloon_r .face_icon {
  order: 2 !important;
}

.says {
  max-width: 300px;
  display: flex;
  flex-wrap: wrap;
  position: relative;
  padding: 10px;
  border-radius: 12px;
  background: #8ee7b6;
  box-sizing: border-box;
  margin: 0 !important;
  line-height: 1.5;
  /*   align-items: center; */
}

.says p {
  margin: 8px 0 0 !important;
}

.says p:first-child {
  margin-top: 0 !important;
}

.says:after {
  content: "";
  position: absolute;
  border: 10px solid transparent;
  margin-top: -3px;
}

.timestamp_l {
  display: block;
  margin-top: 5px;
  font-size: 0.8em;
  padding-left: 5px;
  color: #999;
  text-align: right;
}

.timestamp_r {
  display: block;
  margin-top: 5px;
  font-size: 0.8em;
  padding-right: 5px;
  color: #999;
  text-align: left;
}

.balloon_l .says:after {
  left: -26px;
  border-right: 22px solid #8ee7b6;
}

.balloon_r .says:after {
  right: -26px;
  border-left: 22px solid #8ee7b6;
}
</style>
